import { Api } from "./api";

/**
 * MetrioniQ: dashboard-level permission overrides.
 *
 * Replaces the `DashboardPermissionsApi` entry that used to live in
 * `metabase/services.js`, which upstream deleted in 0.63 along with the rest of
 * the legacy API layer. Mirrors the collection permissions graph endpoints in
 * `metabase/api/collection.ts`.
 */
export type DashboardPermissionValue = "view" | "curate" | "no-access";

export type DashboardPermissionsGraph = {
  revision: number;
  groups: Record<string, Record<string, unknown>>;
};

export type UpdateDashboardPermissionsGraphRequest = {
  revision?: number | null;
  groups: Record<string, Record<string, unknown>>;
};

export const dashboardPermissionsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardPermissionsGraph: builder.query<
      DashboardPermissionsGraph,
      void
    >({
      query: () => ({
        method: "GET",
        url: "/api/dashboard-permissions/graph",
      }),
    }),
    updateDashboardPermissionsGraph: builder.mutation<
      DashboardPermissionsGraph,
      UpdateDashboardPermissionsGraphRequest
    >({
      query: (body) => ({
        method: "PUT",
        url: "/api/dashboard-permissions/graph",
        body,
      }),
    }),
  }),
});

export const {
  useGetDashboardPermissionsGraphQuery,
  useUpdateDashboardPermissionsGraphMutation,
} = dashboardPermissionsApi;
